export default "__VITE_ASSET__DzFPYYtY__"